<template>
  <div class="forum-wrapper">
    <el-header class="forum-header">
      <div class="forum-header-inner">
        <div class="header-left">
          <div class="forum-brand">
            <img src="@/assets/logo.png" alt="Logo" class="brand-logo" />
            <span class="brand-text">论坛</span>
          </div>
        </div>
        
        <div class="header-center">
          <div class="nav-buttons">
            <el-button 
              :type="$route.path === '/forum' ? 'primary' : 'default'"
              @click="go('/forum')"
              class="nav-btn"
            >
              广场首页
            </el-button>
            <el-button 
              :type="$route.path === '/forum/my' ? 'primary' : 'default'"
              @click="goToMyReviews"
              class="nav-btn"
            >
              我的评价
            </el-button>
          </div>
        </div>

        <div class="header-right">
          <el-input
            v-model="keyword"
            placeholder="搜索评价/关键词"
            class="forum-search"
            clearable
            @keyup.enter="onSearch"
          >
            <template #prefix>
              <el-icon><Search /></el-icon>
            </template>
            <template #append>
              <el-button type="primary" @click="onSearch">搜索</el-button>
            </template>
          </el-input>

          <div class="user-menu" v-if="isAuthenticated">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                {{ (currentUser && currentUser.name) || '用户' }}
                <el-icon class="el-icon--right"><ArrowDown /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          
          <div class="auth-links" v-else>
            <el-button type="text" @click="$router.push('/login')">登录</el-button>
            <el-button type="primary" @click="$router.push('/register')">注册</el-button>
          </div>
        </div>
      </div>
    </el-header>
    
    <el-main class="forum-main">
      <div class="forum-main-layout">
        
        <div class="module-bar-horizontal">
          <el-button-group class="horizontal-group">
            <el-button
              v-for="item in modules"
              :key="item.value"
              :type="module === item.value ? 'primary' : 'default'"
              @click="onModuleSelect(item.value)"
              class="module-btn"
            >
              {{ item.label }}
            </el-button>
          </el-button-group>
        </div>
        
        <div class="forum-content">
          <router-view :keyword="keyword" :module="module" @search="onSearch" />
        </div>
      </div>
    </el-main>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ArrowDown, Search } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

const store = useStore()
const keyword = ref('')
const module = ref('')
const router = useRouter()
const route = useRoute()
const modules = [
  { label: '全部', value: '' },
  { label: '辐射校正', value: '辐射校正' },
  { label: '几何校正', value: '几何校正' },
  { label: '大气校正', value: '大气校正' },
  { label: '一站式处理', value: '一站式处理' }
]

const isAuthenticated = computed(() => store.getters['user/isAuthenticated'])
const currentUser = computed(() => store.getters['user/currentUser'])

const handleLogout = async () => {
  await store.dispatch('user/logout')
  router.push('/login')
}

const onSearch = () => {
  if (route.path !== '/forum') {
    router.push({ path: '/forum', query: { keyword: keyword.value } })
  } else {
    router.replace({ path: '/forum', query: { keyword: keyword.value, t: Date.now() } })
  }
}

const onModuleSelect = (val) => {
  module.value = val
  onSearch()
}

watch(() => route.query.keyword, (val) => {
  keyword.value = val || ''
}, { immediate: true })

const goToMyReviews = () => {
  router.push('/forum/my')
}

const go = (path) => {
  router.push(path)
}
</script>

<style scoped>
.forum-wrapper {
  min-height: 100vh;
  background: #fafbfc;
  transition: all 0.3s ease;
}

.forum-wrapper.dark {
  background: #0d1117;
}

.forum-header {
  height: 72px;
  background: #004dff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 999;
}

.forum-header-inner {
  max-width: 1400px;
  height: 100%;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  flex: 1;
}

.header-center {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-shrink: 0;
  margin-right: 100px;
}

.forum-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.brand-logo {
  height: 36px;
}

.brand-text {
  font-size: 20px;
  font-weight: 700;
  color: #24292f;
}

/* 导航按钮组 */
.nav-buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.nav-btn {
  color: #24292f;
  border: 1px solid #d0d7de;
  background: white;
  font-weight: 600;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.nav-btn:hover {
  background: #f6f8fa;
  border-color: #0366d6;
  color: #0366d6;
}

.nav-btn.el-button--primary {
  background: white;
  border-color: #d0d7de;
  color: #24292f;
}

.nav-btn.el-button--primary:hover {
  background: #f6f8fa;
  border-color: #0366d6;
  color: #0366d6;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}

/* 搜索框 */
.forum-search {
  width: 280px;
  border-radius: 999px;
  overflow: hidden;
}

.forum-search .el-input__wrapper {
  background: white;
  border: none;
  border-radius: 999px;
  padding: 0 12px;
}

.forum-search .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 2px rgba(0, 77, 255, 0.2);
}

/* 登录 / 注册按钮 */
.auth-links {
  display: flex;
  align-items: center;
  gap: 12px;
}

.auth-links .el-button {
  border-radius: 20px;
  font-weight: 600;
  padding: 6px 18px;
  font-size: 14px;
  color: white;
  border: 1px solid white;
  background: transparent;
  transition: 0.2s;
}

.auth-links .el-button:hover {
  background: white;
  color: #004dff;
}

/* 用户菜单 */
.user-menu .el-dropdown-link {
  color: white;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.2s;
}

.user-menu .el-dropdown-link:hover {
  background: white;
  color: #004dff;
}

.forum-wrapper.dark .user-menu .el-dropdown-link {
  color: #8b949e;
}

.forum-wrapper.dark .user-menu .el-dropdown-link:hover {
  background: #21262d;
  color: #58a6ff;
}

.forum-main {
  padding: 0;
}

.forum-main-layout {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 24px;
  padding: 20px;
}

.module-bar-vertical {
  width: 70px;
  background: white;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  padding: 8px;
  height: fit-content;
  position: sticky;
  top: 84px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.forum-wrapper.dark .module-bar-vertical {
  background: #161b22;
  border-color: #30363d;
}

.module-title {
  font-size: 14px;
  font-weight: 600;
  color: #24292f;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #d0d7de;
  text-align: center;
}

.forum-wrapper.dark .module-title {
  color: #f0f6fc;
  border-bottom-color: #30363d;
}

.vertical-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.module-btn {
  width: 100%;
  text-align: center;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #586069;
  padding: 8px 4px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
  justify-content: center;
  line-height: 1.4;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.module-btn:hover {
  background: #f6f8fa;
  color: #0366d6;
}

.module-btn.el-button--primary {
  background: #0366d6;
  color: white;
}

.forum-wrapper.dark .module-btn {
  color: #8b949e;
}

.forum-wrapper.dark .module-btn:hover {
  background: #21262d;
  color: #58a6ff;
}

.forum-content {
  flex: 1;
  min-width: 0;
}

/* 响应式设计优化 */
@media (max-width: 1200px) {
  .forum-header-inner {
    padding: 0 16px;
  }
  
  .forum-search {
    width: 240px;
  }
  
  .header-left {
    gap: 24px;
  }
}

@media (max-width: 1024px) {
  .forum-header-inner {
    padding: 0 12px;
  }
  
  .forum-search {
    width: 200px;
  }
  
  .header-left {
    gap: 16px;
  }
  
  .forum-menu .el-menu-item {
    padding: 0 16px;
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .forum-header {
    height: auto;
    min-height: 72px;
  }
  
  .forum-header-inner {
    flex-direction: column;
    padding: 12px;
    gap: 12px;
    align-items: stretch;
  }
  
  .header-left {
    justify-content: center;
    width: 100%;
    gap: 20px;
  }
  
  .header-right {
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 12px;
  }
  
  .forum-search {
    width: 100%;
    max-width: 300px;
  }
  
  .forum-menu {
    height: auto;
  }
  
  .forum-menu .el-menu-item {
    height: 40px;
    line-height: 40px;
    margin-top: 0;
    padding: 0 12px;
    font-size: 14px;
  }
}

/* 暗黑模式切换按钮 */
.theme-toggle {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #0366d6;
  border: none;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(3, 102, 214, 0.3);
  transition: all 0.3s ease;
  z-index: 1000;
}
.module-bar-horizontal{
  width: 180px;
  font-size: 30px;
}
.theme-toggle:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(3, 102, 214, 0.4);
}

.forum-nav-bar {
  background: white;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 0 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.forum-nav-bar .forum-menu {
  background: transparent;
  border: none;
  height: 50px;
}

.forum-nav-bar .forum-menu .el-menu-item {
  font-size: 16px;
  font-weight: 600;
  padding: 0 24px;
  color: #24292f;
  background: transparent;
  transition: all 0.3s ease;
  height: 50px;
  line-height: 50px;
  border: none;
}

.forum-nav-bar .forum-menu .el-menu-item:hover {
  color: #0366d6;
  background: #f6f8fa;
}

.forum-nav-bar .forum-menu .el-menu-item.is-active {
  color: #0366d6;
  background: #f0f5ff;
  border-bottom: 2px solid #0366d6;
}

::v-deep .forum-menu .el-menu-item {
  min-width: 120px !important;
  width: auto !important;
  padding: 0 24px !important;
  font-size: 16px !important;
  white-space: nowrap !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
.header-left, .forum-menu {
  flex-shrink: 0 !important;
}
.forum-header-inner {
  min-width: 400px;
}
.top-nav-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 16px 0;
  justify-content: center;
  margin-left: -150px;
}
</style>






























